var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 8.67196V3.87384C14.9994 3.50329 14.8891 3.14122 14.6831 2.83324C14.4771 2.52526 14.1845 2.28517 13.8422 2.14321C13.4999 2.00125 13.1233 1.96377 12.7598 2.03551C12.3962 2.10725 12.0621 2.28499 11.7994 2.54633L0 14.1863L11.7994 25.8245C11.9731 25.9992 12.1797 26.1378 12.4072 26.2325C12.6347 26.3271 12.8786 26.3758 13.125 26.3758C13.3714 26.3758 13.6153 26.3271 13.8428 26.2325C14.0703 26.1378 14.2769 25.9992 14.4506 25.8245C14.6248 25.6505 14.763 25.4438 14.8573 25.2163C14.9516 24.9889 15 24.7451 15 24.4988V19.832C20.1562 19.9595 25.7906 20.8932 30 27.3113V25.4363C30 16.7495 23.4375 9.60571 15 8.67196Z","fill":"currentColor"}));
}

Back.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Back;

Back.default = Back;
